import * as React from 'react';
import ReactInputMask from 'react-input-mask';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const inputVariants = cva(
  'flex h-10 w-full rounded-md border border-primary-lightest bg-background px-3 py-2 text-neutral ring-offset-background placeholder:text-neutral-light text-base md:text-sm ' +
    'hover:text-neutral-dark hover:border-neutral-light hover:bg-bright ' +
    'focus-visible:outline-none focus-visible:text-neutral-dark focus-visible:border-neutral-dark ' +
    'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground ' +
    'disabled:cursor-not-allowed disabled:opacity-50 ' +
    'transition-colors duration-150 ' +
    '[&[aria-invalid=true]]:border-danger',
  {
    variants: {
      endIcon: {
        true: 'pe-9'
      }
    },
    defaultVariants: {
      endIcon: false
    }
  }
);

const Input = React.forwardRef(({ className, type, endIcon, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn('c-input', inputVariants({ endIcon }), className)}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

const InputMask = React.forwardRef(({ className, disabled, ...props }, ref) => {
  return (
    <ReactInputMask
      disabled={disabled}
      {...props}
    >
      {inputProps => (
        <Input
          ref={ref}
          disabled={disabled || inputProps.disabled}
          className={cn(className)}
          {...inputProps}
        />
      )}
    </ReactInputMask>
  );
});
InputMask.displayName = 'InputMask';

const InputPassword = React.forwardRef(({ className, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={showPassword ? 'text' : 'password'}
        className={cn('peer', className)}
        endIcon
        {...props}
      />
      <button
        type="button"
        aria-label="Alterar visibilidade da senha"
        title="Alterar visibilidade da senha"
        className="absolute inset-y-0 end-0 flex items-center justify-center pe-3 text-primary-dark peer-disabled:opacity-50 [&_svg]:size-4"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <FiEye aria-hidden="true" /> : <FiEyeOff aria-hidden="true" />}
      </button>
    </div>
  );
});
InputPassword.displayName = 'InputPassword';

export { Input, InputMask, InputPassword };
